import React, { Component } from 'react';
import './style.css';
import { Input, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import history from './../../../../utils/history';
import Loader from './../../loader/loader';
import { FormattedMessage } from 'react-intl';
import { sendData } from '../../../../analytics/sendData';
class TarotReading extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isFlippedLove: false,
            isFlippedMood: false,
            isFlippedCareer: false,
            firstName: '',
            contentLoading: true,
            randomReading: 0
        }

    }
    getRandomInt(min, max) {
        return Math.round((Math.random() * (max - min) + min) / 3) * 3;
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        setTimeout(() => this.setState({ contentLoading: false }), 1500);
        const randomReading = this.getRandomInt(0, 12);
        this.setState({
            randomReading
        })
        sendData('', 'tarot', 'viewed');
    }
    validation = () => {
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        let cardAlertMessage,nameAlertMessage;
        if (countryCode.countryCode === 'fr') {
            cardAlertMessage = "Veuillez sélectionner toutes les cartes";
            nameAlertMessage="S'il vous plaît entrer le prénom."
        }else if (countryCode.countryCode === 'eg') {
            cardAlertMessage = "من فضلك اختر كل البطاقات";
            nameAlertMessage="يرجى إدخال الاسم الأول"
        } else if (countryCode.countryCode === 'gr') {
            cardAlertMessage = "Διαλέξτε μια κάρτα.";
            nameAlertMessage="Γράψτε το όνομά σας!"
        }else{
            cardAlertMessage = "Please select all card.";
            nameAlertMessage="Please enter the first name"
        }
        if (this.state.isFlippedLove === false || this.state.isFlippedMood === false || this.state.isFlippedCareer === false) {
            alert(cardAlertMessage);
            return false;
        } else if (this.state.firstName === '') {
            alert(nameAlertMessage);
            return false;
        }
        else {
            return true
        }
    }

    handleDailyreading = () => {
        sendData('', 'tarot', 'engaged');
        if (this.validation()) {
            history.push({
                pathname: '/dailyTarot',
                state: { name: this.state.firstName, reading: this.state.randomReading }
            });
        }
    }
    handleInput = (value) => {
        this.setState({
            firstName: value
        });
    }

    showBack = (val) => {
        sendData('', 'tarot', 'engaged');
        if (val === 'love') {
            this.setState({
                isFlippedLove: true
            });
        } else if (val === 'mood') {
            this.setState({
                isFlippedMood: true
            });
        } else if (val === 'career') {
            this.setState({
                isFlippedCareer: true
            });
        }

    }
    render() {
        const { contentLoading, randomReading } = this.state;
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        if (contentLoading) {
            return <Loader />
        }
        return (
            <div className="checkastronow-tarotreading">
                    <div className="tarot-item checkastronow-tarot-headeing">
                        <div className={countryCode.countryCode==='eg'? "can-tarotreading-btn-section-arabic":"can-tarotreading-btn-section"}>
                            <Link to="/"><img src={require('./../../../assets/images/back-button.png')} className="back-button" /></Link>
                        </div>
                        <div className="checkastronow-heading-title">
                            <h1>
                                <FormattedMessage id="tarotreading.title"
                                    defaultMessage="Tarot Reading"
                                    description=""
                                    values={{}} />
                            </h1>
                        </div>
                    </div>
                    <div className="checkastronow-tarotreading-box">
                    <div className="tarot-item">
                        <p className="text-bold checkastronow-text-color can-big">
                            <FormattedMessage id="tarotreading.subtitle"
                                defaultMessage="Daily Tarot"
                                description=""
                                values={{}} />
                        </p>
                        <p>
                            <FormattedMessage id="tarotreading.paragraph"
                                defaultMessage="Tarot doesn't have the power to change future events, but it can help you anticipate them. Discover our daily tarot reading, the perfect way to start your day."
                                description=""
                                values={{}} />
                        </p>
                    </div>
                    <div className="tarot-item">
                        <div className="checkastronow-tarot-card-section">
                            <h2 className="first-name-title">
                                <FormattedMessage id="tarotreading.enterName.title"
                                    defaultMessage="Enter your first name"
                                    description=""
                                    values={{}} />

                            </h2>
                            <div className="checkastronow-input-container">
                                <FormattedMessage
                                    defaultMessage="First name"
                                    id='tarotreading.input.placeholder'>
                                    {placeholder => <Input onChange={e => this.handleInput(e.target.value)} placeholder={placeholder} className="checkastronow-tarot-input" />}
                                </FormattedMessage>
                                <div className="checkastronow-btn-section">
                                <Button onClick={this.handleDailyreading} className="checkastronow-tarotreading-btn">
                                    <FormattedMessage id="tarotreading.button"
                                        defaultMessage="Read Now"
                                        description=""
                                        values={{}} />
                                </Button>
                                </div>
                            </div>

                            {/* <Input onChange={e => this.handleInput(e.target.value)} placeholder="First name" className="tarot-input" /> */}
                            <div className="checkastronow-tarot-card">
                                <div className="card-container  card-right-margin">
                                    <div onClick={() => this.showBack('love')} className={this.state.isFlippedLove ? "card flip" : "card"} style={{ float: 'left' }}>
                                        <div className="side">
                                            <img src={require('./../../../assets/images/love-tarot.png')} width="190" height="150" />
                                        </div>
                                        <div className="side back">
                                            <img src={require(`./../../../assets/images/tarotcards/tarot-card-${randomReading}.jpg`)} width="190" height="150" />
                                        </div>
                                    </div>
                                </div>
                                <div className="card-container card-right-margin">
                                    <div onClick={() => this.showBack('mood')} className={this.state.isFlippedMood ? "card flip" : "card"} style={{ float: 'left' }}>
                                        <div className="side">
                                            <img src={require('./../../../assets/images/mood-tarot.png')} width="190" height="150" />
                                        </div>
                                        <div className="side back">
                                            <img src={require(`./../../../assets/images/tarotcards/tarot-card-${randomReading + 1}.jpg`)} width="190" height="150" />
                                        </div>
                                    </div>
                                </div>
                                <div className={countryCode.countryCode==='eg'? "card-container card-right-margin":"card-container"}>
                                    <div onClick={() => this.showBack('career')} className={this.state.isFlippedCareer ? "card flip" : "card"} style={{ float: 'left' }}>
                                        <div className="side">
                                            <img src={require('./../../../assets/images/career-tarot.png')} width="190" height="150" />
                                        </div>
                                        <div className="side back">
                                            <img src={require(`./../../../assets/images/tarotcards/tarot-card-${randomReading + 2}.jpg`)} width="190" height="150" />
                                        </div>
                                    </div>
                                </div>
                                {/* <img src={require('./../../../assets/images/mood-tarot.png')} width="190" height="150" /> */}
                                {/* <img src={require('./../../../assets/images/career-tarot.png')} width="190" height="150" /> */}
                            </div>
                        </div>
                        

                    </div>

                </div>
            </div>
        )
    }
}

export default TarotReading;


// WEBPACK FOOTER //
// ./src/checkastronow/components/screens/tarotreading/tarotReading.js